import React from 'react';

const Loader = () => (
  <img className="loading_icon" src="/loading.gif" alt="loading indicatator"/>
);

export default Loader; 